import { getImageUrl, removeFromImageCache } from '../firebase/storageService';

const CACHE_TTL = 60 * 60 * 1000; // 1 hora
const memoryCache = {};

export const buildPatientImageCacheKey = (pacienteId) => `patient_image_${pacienteId}`;

export const readPatientImageCacheEntry = (pacienteId) => {
  const cacheKey = buildPatientImageCacheKey(pacienteId);
  const now = Date.now();

  const memoryEntry = memoryCache[cacheKey];
  if (memoryEntry && now - memoryEntry.timestamp < CACHE_TTL) {
    return memoryEntry.url;
  }

  try {
    const storedEntry = localStorage.getItem(cacheKey);
    if (storedEntry) {
      const parsed = JSON.parse(storedEntry);
      if (now - parsed.timestamp < CACHE_TTL) {
        memoryCache[cacheKey] = parsed;
        return parsed.url;
      }
      localStorage.removeItem(cacheKey);
    }
  } catch {
    localStorage.removeItem(cacheKey);
  }

  delete memoryCache[cacheKey];
  return null;
};

export const writePatientImageCacheEntry = (pacienteId, url) => {
  if (!url) return;
  const cacheKey = buildPatientImageCacheKey(pacienteId);
  const entry = { url, timestamp: Date.now() };
  memoryCache[cacheKey] = entry;
  try {
    localStorage.setItem(cacheKey, JSON.stringify(entry));
  } catch {
    // quota ou modo privado
  }
};

export const invalidatePatientImageCache = (pacienteId) => {
  const idStr = String(pacienteId);
  const cacheKey = buildPatientImageCacheKey(idStr);
  delete memoryCache[cacheKey];
  removeFromImageCache('patient', idStr);
  try {
    localStorage.removeItem(cacheKey);
  } catch {
    // ignorar
  }
};

export const getPatientImageWithCache = async (pacienteId) => {
  const cachedUrl = readPatientImageCacheEntry(pacienteId);
  if (cachedUrl) return cachedUrl;

  try {
    const url = await getImageUrl('patient', pacienteId.toString());
    if (url) {
      writePatientImageCacheEntry(pacienteId, url);
      return url;
    }
  } catch (err) {
    console.error(`Erro ao carregar imagem do paciente ${pacienteId}:`, err);
  }

  return null;
};
